import GlobalModel from 'echarts/lib/model/Global';
import { DvLineSeriesModel } from './type';

export function eachLineSeriesModel(
  ecModel: GlobalModel,
  cb: (model: DvLineSeriesModel, index: number) => void
) {
  const lineModels = ecModel.getSeriesByType('line');
  lineModels.forEach(cb);
}
